import { Clip } from '@goldcast/player-config/src/types/clip-types';
import { getPlayerTimeFromSegmentTime } from '@/Pages/Clip/ClipPlayer/ClipNewTimeline/timeUtils';
import type { ChapterParagraph } from '@/components/molecules/Transcript/types';

export const getChapterPlayerTime = (chapter: ChapterParagraph, clipData: Clip, isSplitsEnabled: boolean): number => {
  return isSplitsEnabled ? chapter.start : getPlayerTimeFromSegmentTime(chapter.start, clipData, chapter.segmentId);
};
